/** @format */
import React from 'react'
import { _$, Dialog, Form, FormItem, Input, Message } from '@king-design/react'
import ApiGroup from 'src/api/ApiGroup'
import { request } from 'src/utils'

interface ICreateGroupDialogProps {
  visible: boolean
  onClose: () => void
  update: () => void
}

const CreateGroupDialog: React.FC<ICreateGroupDialogProps> = ({ visible, onClose, update }) => {
  const [groupName, setGroupName] = React.useState<string>('')
  const formRef = React.useRef<any>()

  const handleSubmit = async () => {
    const validate = await formRef.current.validate()
    if (validate) {
      const result = await request(ApiGroup.createGroup, {
        method: 'POST',
        data: {
          GroupName: groupName
        }
      })
      if (result.code === 'Success') {
        Message.success(_$('创建成功'))
        setGroupName('')
        onClose()
        update()
      }
    }
  }

  return (
    <Dialog
      width={500}
      title={_$('新建资源分组')}
      value={visible}
      ok={handleSubmit}
      onChangeValue={show => {
        if (!show) {
          setGroupName('')
          onClose()
        }
      }}
    >
      <Form starOnRequired ref={formRef} labelWidth={100}>
        <FormItem
          label={_$('资源分组名称')}
          value={groupName}
          rules={{ required: true, userName: true }}
          messages={{
            required: _$('请输入资源分组名称')
          }}
        >
          <Input
            value={groupName}
            placeholder={_$('请输入资源分组名称')}
            onChangeValue={value => setGroupName(value)}
          ></Input>
        </FormItem>
      </Form>
    </Dialog>
  )
}

export default CreateGroupDialog
